import moment from '@g4/moment-utc';
import get from 'lodash/get';
import { DEPARTING, tripTypeValues } from './constants';
import { useCallback } from 'react';
import omit from 'lodash/omit';

const useRoundTripConverter = (
  tabDates,
  setDepartingTabs,
  setReturningTabs,
  searchCriteria,
  setSearchCriteria,
  flightsQuery
) => {
  const departingSelectedTabDate = moment(
    get(tabDates[DEPARTING], 'selected')
  ).format('YYYY-MM-DD');

  const { client } = flightsQuery;

  const makeOneway = useCallback(() => {
    /**
     * The cached searched criteria returns the same data even after search criteria gets modified.
     * This results in incorrect flights query response.
     * This is happening when changing the trip type from RT to OW and vice versa .
     * To avoid this, the search criteria cache has to be invalidated.
     */
    Object.keys(client.cache.data.data).forEach(
      key =>
        key.indexOf('flightSearchCriteria') >= 0 &&
        client.cache.data.delete(key)
    );

    setSearchCriteria({
      ...omit(searchCriteria, 'returnDate'),
      tripType: tripTypeValues.ONEWAY,
      departDate: {
        ...searchCriteria.departDate,
        date: departingSelectedTabDate,
      },
    });
    setReturningTabs({ selected: null, middle: null });
  }, [
    searchCriteria,
    departingSelectedTabDate,
    setReturningTabs,
    setSearchCriteria,
    client.cache.data,
  ]);

  const makeRoundtrip = useCallback(
    incentiveReturnDate => {
      let returnDate;
      if (incentiveReturnDate) {
        returnDate = moment(incentiveReturnDate);
      } else {
        returnDate = moment(departingSelectedTabDate).add(1, 'd');
      }

      const departDate = moment(departingSelectedTabDate);
      const formattedDate = returnDate.format('YYYY-MM-DD');

      setSearchCriteria({
        ...searchCriteria,
        departDate: {
          date: departDate.format('YYYY-MM-DD'),
        },
        returnDate: {
          date: returnDate.format('YYYY-MM-DD'),
        },
        tripType: tripTypeValues.ROUNDTRIP,
      });

      setReturningTabs({ selected: formattedDate, middle: formattedDate });
    },
    [
      searchCriteria,
      departingSelectedTabDate,
      setReturningTabs,
      setSearchCriteria,
    ]
  );

  return {
    makeOneway,
    makeRoundtrip,
  };
};

export default useRoundTripConverter;
